<template>
  <div class="fontManage">
    <el-table
      stripe
      :data="tableData"
      border
      style="width: 100%"
      height="100%"
      size="mini"
      @sort-change="sortChange"
    >
      <el-table-column
        type="index"
        :width="pagination.endIndex >= 1000 ? 80 : 50"
        align="center"
        :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="字体或工具"
        align="center"
        show-overflow-tooltip
        sortable="custom"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.name"
            class="allowSkip" @click="fontFileClick(scope.row)">{{ scope.row.name }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="fid"
        label="文件名"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.file"
            >{{ scope.row.file.name }}</span
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="notes"
        label="说明"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.notes">{{ scope.row.notes }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="createUser"
        width="95px" label="创建人" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.createUser">
            {{ scope.row.createUser.name }} ({{ scope.row.createUser.employeeNum }})
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="createDateTime" label="上传时间" width="110px" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{scope.row.createDateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        class-name="operation"
        label="操作"
        align="center"
        width="95px"
      >
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
            :open-delay="300"
          >
            <i @click="editFont($event, scope.row)" class="el-icon-edit"></i>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.enable"
            class="item"
            effect="dark"
            content="禁用"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="disableFont($event, scope.row)"
              class="iconfont icon-qiyong"
            ></i>
          </el-tooltip>
          <el-tooltip
            v-else
            class="item"
            effect="dark"
            content="启用"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="enableFont($event, scope.row)"
              class="iconfont icon-jinyong"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="上移"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="moveUpFont($event, scope.row)"
              class="el-icon-arrow-up"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="下移"
            placement="top"
            :open-delay="300"
          >
            <i
              @click="moveDownFont($event, scope.row)"
              class="el-icon-arrow-down"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="getFontSearch"
    ></pagination>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="480px"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="字体名称" size="small" prop="name">
            <el-input
              v-model="dialogForm.name"
              placeholder="输入字体名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="字体文件"
            size="small"
            prop="fid"
            class="uploadBox"
          >
            <input type="file" ref="fileInput" @change="fileChange" />
            <span class="fileText textOverflow">{{ fileText }}</span>
          </el-form-item>
          <el-form-item label="字体说明" size="small" prop="notes">
            <el-input
              v-model="dialogForm.notes"
              placeholder="输入字体说明"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiFontSearch,
  apiFontAdd,
  apiFontUpdate,
  apiFontEnable,
  apiFontDisable,
  apiFontMoveUp,
  apiFontMoveDowm,
} from "@/api/labelTemplate.js";
import { apiUploadFile, apiDownloadFile } from "@/api/filesUpload.js";
export default {
  components: {
    pagination,
    myDialog,
  },
  props: {
    fontSearchForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      dialogTitle: "",
      dialogForm: {},
      dialogRules: {
        name: [
          { required: true, message: "字体名称不能为空！", trigger: "blur" },
          {
            min: 4,
            max: 64,
            message: "长度在 4 到 64 个字符",
            trigger: "change",
          },
        ],
        fid: [
          { required: true, message: "字体文件不能为空！", trigger: "change" },
        ],
        notes: [
          { required: true, message: "字体说明不能为空！", trigger: "change" },
        ],
      },
      fileText: "未选择任何文件",
      labelWidth: this.$store.state.labelWidth,
    };
  },
  methods: {
    // 表格数据
    async getFontSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiFontSearch({
        ...this.fontSearchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getFontSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getFontSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getFontSearch();
    },
    // 添加
    addFontBtn() {
      this.dialogTitle = "添加字体";
      this.$refs.myDialog.dialogVisible = true;
    },
    // 编辑
    editFont(e, row) {
      this.dialogTitle = "修改字体";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: row.id,
        name: row.name,
        fid: row.file ? row.file.id : null,
        notes: row.notes,
      };
      this.fileText = row.file ? row.file.name : "未选择任何文件";
    },
    // 字体文件改变
    async fileChange(e) {
      this.$set(this.dialogForm, "fid", null);
      this.fileText = "未选择任何文件";
      let file = this.$refs.fileInput.files[0];
      e.target.blur();
      if (file) {
        this.fileText = file.name;
        let fd = new FormData();
        fd.append("file", file);
        const res = await apiUploadFile(fd);
        // console.log(res);
        if (res.code == 0) {
          this.dialogForm.fid = res.fid;
        }
      }
    },
    // 确认新建
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (title == "添加字体") {
            res = await apiFontAdd({
              ...this.dialogForm,
            });
            // console.log(res);
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getFontSearch();
              this.$message({
                type: "success",
                message: "添加成功",
              });
            }
          } else if (title == "修改字体") {
            res = await apiFontUpdate({
              ...this.dialogForm,
            });
            // console.log(res);
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getFontSearch();
              this.$message({
                type: "success",
                message: "修改成功",
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.$refs.fileInput.value = "";
      this.fileText = "未选择任何文件";
      this.dialogForm = {};
    },
    // 下载字体文件
    fontFileClick(row) {
      // console.log(row);
      let uri = apiDownloadFile(row.file.id);
      let a = document.createElement("a");
      a.download = row.file.name;
      a.href = uri;
      a.style.display = "none";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    // 禁用
    disableFont(e, row) {
      e.target.blur();
      this.$allOperation(row, "禁用", "字体").then(async () => {
        const res = await apiFontDisable({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFontSearch("noRemove");
          this.$message({
            message: "禁用成功",
            type: "success",
          });
        }
      });
    },
    // 启用
    enableFont(e, row) {
      e.target.blur();
      this.$allOperation(row, "启用", "字体").then(async () => {
        const res = await apiFontEnable({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFontSearch("noRemove");
          this.$message({
            message: "启用成功",
            type: "success",
          });
        }
      });
    },
    // 上移
    moveUpFont(e, row) {
      e.target.blur();
      this.$confirm(`是否上移【${row.name}】？`, "上移字体", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiFontMoveUp({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFontSearch("noRemove");
          this.$message({
            message: "上移成功",
            type: "success",
          });
        }
      });
    },
    // 下移
    moveDownFont(e, row) {
      e.target.blur();
      this.$confirm(`是否下移【${row.name}】？`, "下移字体", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiFontMoveDowm({
          id: row.id,
        });
        // console.log(res)
        if (res.code == 0) {
          this.getFontSearch("noRemove");
          this.$message({
            message: "下移成功",
            type: "success",
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scope>
.fontManage {
  height: 100%;
  display: flex;
  flex-direction: column;
  .uploadBox {
    position: relative;
    .fileText {
      width: 250px;
      position: absolute;
      top: 0;
      left: 73px;
      background-color: var(--bgPanel);
    }
  }
}
</style>